import { GraphDataset } from './models/GraphDataset.interface';
import { GraphEdge } from "./models/GraphEdge.interface";
import { GraphNode } from "./models/GraphNode.interface";





export class GDataGraph {
    private nodeMap = new Map<string, GraphNode>();
    private nodeEdgesMap = new Map<string, GraphEdge[]>();
    constructor(
        public dataset: GraphDataset,
    ) {
            this.initNodeMap();
            this.initEdgeMapMap();
    }
    private initNodeMap() {
        this.dataset.nodes.forEach(n => {
            this.nodeMap.set(n.id, n);
        })
    }

    private initEdgeMapMap() {
        this.dataset.edges.forEach(e => {
            if (!this.nodeEdgesMap.has(e.source)){
                this.nodeEdgesMap.set(e.source, []);
            }
            const list = this.nodeEdgesMap.get(e.source);
            list.push(e);
        })
        this.dataset.edges.forEach(e => {
            if (!this.nodeEdgesMap.has(e.target)){
                this.nodeEdgesMap.set(e.target, []);
            }
            const list = this.nodeEdgesMap.get(e.target);
            list.push(e);
        })
    }
    getNode(nodeId: string): GraphNode {
        if (!this.nodeMap.has(nodeId)) {
            return undefined;
        }
        return this.nodeMap.get(nodeId);
    }

    getEdges(nodeId: string) {
        return this.nodeEdgesMap.get(nodeId);
    }

    getDisabledRatioIn(nodeId: string): number {
        const incomingEdges = this.getIncomingEdges(nodeId);
        const disabledIncomingEdges = incomingEdges.filter(e => !e.active)
        const disabledIncomingRatio = disabledIncomingEdges.length / incomingEdges.length;
        return disabledIncomingRatio;
    }

    getDisabledRatioOut(nodeId:string): number {
        const outgoingEdges = this.getOutgoingEdges(nodeId);
        const disabledOutgoingEdges = outgoingEdges.filter(e => !e.active)
        const disabledOutgoingRatio = disabledOutgoingEdges.length / outgoingEdges.length;
        return disabledOutgoingRatio;
    }

    getDisabledRatio(nodeId:string): number {
        const edges = this.getEdges(nodeId);
        const disabledEdges = edges.filter(e => !e.active)
        const disabledRatio = disabledEdges.length / edges.length;
        return disabledRatio;
    }

    getChannelIds(nodeId: string): string[] {
        const edges = this.nodeEdgesMap.get(nodeId);
        const set = new Set<string>(edges.map(e => e.id));
        return Array.from(set);
    }

    getDisabledChannelIds(nodeId: string): string[] {
        const edges = this.getIncomingEdges(nodeId);
        const set = new Set<string>(edges.map(e => e.id));
        return Array.from(set);
    }

    getActiveChannelIds(nodeId: string): string[] {
        const edges = this.nodeEdgesMap.get(nodeId).filter(e => e.active);
        const set = new Set<string>(edges.map(e => e.id));
        return Array.from(set);
    }

    getOutgoingEdges(nodeId: string) {
        return this.nodeEdgesMap.get(nodeId).filter(e=> e.source === nodeId);
    }

    getIncomingEdges(nodeId: string) {
        return this.nodeEdgesMap.get(nodeId).filter(e=> e.target === nodeId);
    }
}



